/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ActionResource } from '../model/models';
import { AppHttpResourcesV1ContactsOverviewResource } from '../model/models';
import { ContactResource } from '../model/models';
import { ContactSourceResource } from '../model/models';
import { CreateContactRequest } from '../model/models';
import { GetUserContactsCount200Response } from '../model/models';
import { InlineObject } from '../model/models';
import { InlineObject1 } from '../model/models';
import { InquiryContactResource } from '../model/models';
import { OfferContactResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface ContactServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Contact action list
     * 
     * @param callId 
     */
    contactActionList(callId: number, extraHttpRequestParams?: any): Observable<Array<ActionResource>>;

    /**
     * Contact detail
     * 
     * @param callId 
     */
    contactDetail(callId: number, extraHttpRequestParams?: any): Observable<ContactResource>;

    /**
     * Contact list
     * 
     */
    contactList(extraHttpRequestParams?: any): Observable<Array<ContactResource>>;

    /**
     * Contacts overview
     * 
     */
    contactsOverview(extraHttpRequestParams?: any): Observable<Array<AppHttpResourcesV1ContactsOverviewResource>>;

    /**
     * Contacts source
     * 
     */
    contactsSource(extraHttpRequestParams?: any): Observable<Array<ContactSourceResource>>;

    /**
     * Create contact
     * 
     * @param createContactRequest 
     */
    createContact(createContactRequest: CreateContactRequest, extraHttpRequestParams?: any): Observable<Array<string>>;

    /**
     * Get user contacts count
     * 
     * @param userId 
     */
    getUserContactsCount(userId?: number, extraHttpRequestParams?: any): Observable<GetUserContactsCount200Response>;

    /**
     * Get user to inquiry contacts count
     * 
     * @param userId 
     */
    getUserInquiryContactsCount(userId?: number, extraHttpRequestParams?: any): Observable<GetUserContactsCount200Response>;

    /**
     * Get user to offer contacts count
     * 
     * @param userId 
     */
    getUserOfferContactsCount(userId?: number, extraHttpRequestParams?: any): Observable<GetUserContactsCount200Response>;

    /**
     * Inquiry contact detail
     * 
     * @param callId 
     */
    inquiryContactDetail(callId: number, extraHttpRequestParams?: any): Observable<InquiryContactResource>;

    /**
     * Inquiry contact list
     * 
     */
    inquiryContactList(extraHttpRequestParams?: any): Observable<Array<InquiryContactResource>>;

    /**
     * Offer contact an action list
     * 
     * @param callId 
     */
    offerContactActionList(callId: number, extraHttpRequestParams?: any): Observable<Array<ActionResource>>;

    /**
     * Offer contact detail
     * 
     * @param callId 
     */
    offerContactDetail(callId: number, extraHttpRequestParams?: any): Observable<OfferContactResource>;

    /**
     * Offer a contact list
     * 
     */
    offerContactList(extraHttpRequestParams?: any): Observable<Array<OfferContactResource>>;

    /**
     * Update contact
     * 
     * @param contactId 
     * @param createContactRequest 
     */
    updateContact(contactId: number, createContactRequest: CreateContactRequest, extraHttpRequestParams?: any): Observable<Array<string>>;

}
